import { Component, ReactNode, ErrorInfo } from 'react'

interface SafeMarkdownProps {
  children: ReactNode
  fallback: ReactNode
}

interface SafeMarkdownState {
  hasError: boolean
}

export class SafeMarkdown extends Component<
  SafeMarkdownProps,
  SafeMarkdownState
> {
  constructor(props: SafeMarkdownProps) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Markdown rendering error:', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback
    }

    return this.props.children
  }
}
